define("shared/components/shared/post-tagging/select/tag-select-multiple", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <PowerSelectMultiple
    @closeOnSelect={{false}}
    @disabled={{@disabled}}
    @dropdownClass={{@dropdownClass}}
    @labelText={{@labelText}}
    @onChange={{@onChange}}
    @onClose={{@onClose}}
    @onOpen={{@onOpen}}
    @options={{@options}}
    @placeholder={{@placeholder}}
    @selected={{@selected}}
    @triggerClass={{@triggerClass}}
    class={{@containerClass}}
    data-test-id={{@dataTestId}}
    as |filter select|
  >
    <Shared::PostTagging::Select::TagSelectItem @item={{filter}} @select={{select}} />
  </PowerSelectMultiple>
  */
  {
    "id": "iLGAOnpv",
    "block": "[[[8,[39,0],[[16,0,[30,1]],[16,\"data-test-id\",[30,2]]],[[\"@closeOnSelect\",\"@disabled\",\"@dropdownClass\",\"@labelText\",\"@onChange\",\"@onClose\",\"@onOpen\",\"@options\",\"@placeholder\",\"@selected\",\"@triggerClass\"],[false,[30,3],[30,4],[30,5],[30,6],[30,7],[30,8],[30,9],[30,10],[30,11],[30,12]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[39,1],null,[[\"@item\",\"@select\"],[[30,13],[30,14]]],null],[1,\"\\n\"]],[13,14]]]]]],[\"@containerClass\",\"@dataTestId\",\"@disabled\",\"@dropdownClass\",\"@labelText\",\"@onChange\",\"@onClose\",\"@onOpen\",\"@options\",\"@placeholder\",\"@selected\",\"@triggerClass\",\"filter\",\"select\"],false,[\"power-select-multiple\",\"shared/post-tagging/select/tag-select-item\"]]",
    "moduleName": "shared/components/shared/post-tagging/select/tag-select-multiple.hbs",
    "isStrictMode": false
  });
  class TagSelectMultipleComponent extends _component2.default {}
  _exports.default = TagSelectMultipleComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TagSelectMultipleComponent);
});